import produce from 'immer'

import { USER_AGENT, AUTH } from 'store/actions/types'
import { RegistererState, TransportState } from 'sip.js'

const initialState = {
    registeredStatus: '',
    userAgentStatus: '',
    transportStatus: '',
    connectionError: false,
    reconnectionFailed: false,
    appStartAudioPlayed: false,
    codecCapabilities: []
}

export default function userAgentReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case USER_AGENT.CHANGE_USER_AGENT:
            return produce(state, (draft) => {
                draft.userAgentStatus = payload
            })

        case USER_AGENT.CHANGE_TRANSPORT:
            return produce(state, (draft) => {
                draft.transportStatus = payload

                if(payload === TransportState.Disconnected) {
                    draft.registeredStatus = RegistererState.Terminated;
                }
        
                // Reset values after reconnect
                if (payload === TransportState.Connected && state.transportStatus === TransportState.Disconnected) {
                    state.connectionError && (draft.connectionError = false)
                    state.reconnectionFailed && (draft.reconnectionFailed = false)
                }
            })

        case USER_AGENT.CHANGE_REGISTER_STATUS:
            return produce(state, (draft) => {
                draft.registeredStatus = payload

                if(payload === RegistererState.Registered) {
                    draft.transportStatus = TransportState.Connected;
                    state.connectionError && (draft.connectionError = false)
                    state.reconnectionFailed && (draft.reconnectionFailed = false)
                }
            })

        case AUTH.SIGNOUT_USER_SUCCESS:
            return produce(state, (draft) => {
                draft.connectionError = false
                draft.reconnectionFailed = false
                draft.userAgentStatus = ''
                draft.registeredStatus = ''
                draft.transportStatus = ''
            })

        case USER_AGENT.SET_CONNECTION_ERROR:
            return produce(state, (draft) => {
                draft.connectionError = payload
            })

        case USER_AGENT.SET_RECONNECTION_FAILED:
            return produce(state, (draft) => {
                draft.reconnectionFailed = payload

                // Dismiss connection error alert when reconect finish unsuccesfully
                if (state.connectionError && payload) {
                    draft.connectionError = false
                }
            })

        case USER_AGENT.SET_CODEC_CAPABILITIES:
            return produce(state, (draft) => {
                draft.codecCapabilities = payload
            })
        default:
            return state
    }
}
